import { Type } from "class-transformer";
import { Auftrag } from "../Auftrag";
import { IAuftrag } from "../IAuftrag";
import { IBudgetantragKostenherleitung } from "../IBudgetantragKostenherleitung";
import { BudgetantragKostenherleitung } from "../budgetantragKostenherleitung";
import { IKostengruppe } from "../IKostengruppe";
import { Kostengruppe } from "../Kostengruppe";
import { ITeilleistung } from "../ITeilleistung";
import { Teilleistung } from "../Teilleistung";
import { IKostenermittlungsart } from "../IKostenermittlungsart";
import { Kostenermittlungsart } from "../Kostenermittlungsart";

export interface IKostenherleitungViewModel {
    kostenherleitungen: IBudgetantragKostenherleitung[] | null;
    kostengruppen: IKostengruppe[] | null;
    teilleistungen: ITeilleistung[] | null;
    kostenermittlungsarten: IKostenermittlungsart[] | null;
}

export class KostenherleitungViewModel implements IKostenherleitungViewModel {
    
    static default = {
        kostenherleitungen: [],
        kostengruppen: [],
        teilleistungen: [],
        kostenermittlungsarten: [],
    }

    @Type(() => BudgetantragKostenherleitung)
    public kostenherleitungen: BudgetantragKostenherleitung[] | null;
    @Type(() => Kostengruppe)
    public kostengruppen: Kostengruppe[] | null;
    @Type(() => Teilleistung)
    public teilleistungen: Teilleistung[] | null;
    @Type(() => Kostenermittlungsart)
    public kostenermittlungsarten: Kostenermittlungsart[] | null;

    constructor(kostenherleitungen: IBudgetantragKostenherleitung[] | null,
                kostengruppen: IKostengruppe[] | null,
                teilleistungen: ITeilleistung[] | null,
                kostenermittlungsarten: Kostenermittlungsart[] | null) {

        this.kostenherleitungen = kostenherleitungen;
        this.kostengruppen = kostengruppen;
        this.teilleistungen = teilleistungen;
        this.kostenermittlungsarten = kostenermittlungsarten;
    }
}

